import { render, staticRenderFns } from "./AccreditationForm.vue?vue&type=template&id=8d47f20e&scoped=true&"
import script from "./AccreditationForm.vue?vue&type=script&lang=js&"
export * from "./AccreditationForm.vue?vue&type=script&lang=js&"
import style0 from "./AccreditationForm.vue?vue&type=style&index=0&id=8d47f20e&scoped=true&lang=css&"
import style1 from "./AccreditationForm.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d47f20e",
  null
  
)

export default component.exports